import { ConfigFilterItem } from 'Core/interfaces'

export enum CurrencyRateFilterFields {
	effectiveStartDateFrom = 'effectiveStartDateFrom',
	effectiveStartDateTo = 'effectiveStartDateTo',
	fromCurrencyId = 'fromCurrencyId',
	toCurrencyId = 'toCurrencyId'
}

export declare namespace CurrencyRate {
	interface Basic {
		fromCurrency: Entity
		toCurrency: Entity
		effectiveStartDate: BasicString
		rateMultiplier: number
		rateDivider: number
	}
	namespace Filter {
		interface Config {
			[CurrencyRateFilterFields.effectiveStartDateFrom]: ConfigFilterItem<string, BasicString>
			[CurrencyRateFilterFields.effectiveStartDateTo]: ConfigFilterItem<string, BasicString>
			[CurrencyRateFilterFields.fromCurrencyId]: ConfigFilterItem<string, BasicString>
			[CurrencyRateFilterFields.toCurrencyId]: ConfigFilterItem<string, BasicString>
		}
	}
}
